export const set = (state, action) => {
  return { ...state, selectedProductForComparison: action.payload }
}
